/**
 * providerMeta — общие метки/цвета провайдеров для админ-компонентов
 * (ApiKeysConfig «кирпичики» с цветной плашкой, CarouselsConfig,
 * ModuleConfigsAdmin). Один источник истины, чтобы цвета
 * не расползались по файлам.
 */
import type { ProviderName } from '@/hooks/useAdmin';

export const PROVIDER_LABELS: Record<ProviderName, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  google: 'Google Gemini',
  openrouter: 'OpenRouter',
  perplexity: 'Perplexity',
  deepl: 'DeepL',
  serpapi: 'SerpAPI',
};

/** Метка провайдера (строкой, безопасно для чужих значений). */
export function providerLabel(value: string): string {
  return PROVIDER_LABELS[value as ProviderName] ?? value;
}

/** Цветная плашка провайдера (bg/text/border классы). */
export const PROVIDER_COLORS: Record<ProviderName, string> = {
  openai: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/25',
  anthropic: 'bg-orange-500/15 text-orange-400 border-orange-500/25',
  google: 'bg-sky-500/15 text-sky-400 border-sky-500/25',
  openrouter: 'bg-violet-500/15 text-violet-400 border-violet-500/25',
  perplexity: 'bg-teal-500/15 text-teal-400 border-teal-500/25',
  deepl: 'bg-indigo-500/15 text-indigo-400 border-indigo-500/25',
  serpapi: 'bg-amber-500/15 text-amber-400 border-amber-500/25',
};

/** Цветная плашка по строковому значению провайдера. */
export function providerBadge(value: string): string {
  return (
    PROVIDER_COLORS[value as ProviderName] ??
    'bg-surface-700/30 text-surface-400 border-surface-700'
  );
}

/** Классы метки тарифа (эконом/оптимал/макс/супер) — для ключей и каруселей. */
export const TIER_CHIP_CLASSES: Record<string, { on: string; off: string }> = {
  economy: {
    on: 'bg-success-tint/10 text-success border-success-tint/25',
    off: 'border border-surface-700 text-surface-500',
  },
  optimal: {
    on: 'bg-primary-500/10 text-primary-400 border-primary-500/25',
    off: 'border border-surface-700 text-surface-500',
  },
  max: {
    on: 'bg-warning-tint/10 text-warning border-warning-tint/25',
    off: 'border border-surface-700 text-surface-500',
  },
  super: {
    on: 'bg-fuchsia-500/10 text-fuchsia-400 border-fuchsia-500/25',
    off: 'border border-surface-700 text-surface-500',
  },
};